import { useState, useEffect, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export interface Announcement {
  id: string;
  title: string;
  content: string;
  category: "haber" | "duyuru" | "blog" | "kampanya";
  author: string;
  publishedAt: string;
  image?: string;
  pinned?: boolean;
  tags?: string[];
}

const CATEGORY_LABELS: Record<string, string> = {
  haber: "Haber",
  duyuru: "Duyuru",
  blog: "Blog",
  kampanya: "Kampanya",
};

const CATEGORY_COLORS: Record<string, string> = {
  haber: "bg-sky-100 text-sky-700",
  duyuru: "bg-amber-100 text-amber-700",
  blog: "bg-emerald-100 text-emerald-700",
  kampanya: "bg-rose-100 text-rose-700",
};

const SEED_ANNOUNCEMENTS: Announcement[] = [
  {
    id: "ann-1",
    title: "Türkiye Seyahat Rehberi'ne Hoş Geldiniz!",
    content: "Türkiye'nin dört bir yanından en iyi restoranları, konaklama işletmelerini ve gezi rotalarını bir araya getiren platformumuza hoş geldiniz. Editörlerimiz tarafından özenle seçilen içeriklerle seyahat planlamanızı kolaylaştırıyoruz. Yeni özellikler ve içerikler için bizi takip etmeye devam edin!",
    category: "duyuru",
    author: "Editör Ekibi",
    publishedAt: "2025-01-15T10:00:00Z",
    image: "https://readdy.ai/api/search-image?query=Turkey%20travel%20guide%20welcome%20announcement%20colorful%20map%20destinations%20beautiful%20landscape%20warm%20tones%20editorial%20style&width=800&height=400&seq=ann-welcome&orientation=landscape",
    pinned: true,
    tags: ["platform", "yeni", "hoşgeldiniz"],
  },
  {
    id: "ann-2",
    title: "Karadeniz Yayla Rehberi Yayında!",
    content: "Karadeniz'in eşsiz yaylalarını keşfetmek isteyenler için kapsamlı rehberimiz yayına girdi. Ayder, Pokut, Sal ve daha pek çok yayla hakkında detaylı bilgiler, ulaşım ipuçları ve konaklama önerileri rehberimizde sizi bekliyor. Doğanın kalbinde unutulmaz bir tatil için hemen inceleyin.",
    category: "blog",
    author: "Ahmet Yılmaz",
    publishedAt: "2025-01-20T09:00:00Z",
    image: "https://readdy.ai/api/search-image?query=Karadeniz%20yayla%20green%20mountains%20Black%20Sea%20Turkey%20highland%20plateau%20misty%20fog%20lush%20nature%20scenic&width=800&height=400&seq=ann-karadeniz&orientation=landscape",
    tags: ["karadeniz", "yayla", "rehber"],
  },
  {
    id: "ann-3",
    title: "Yeni Restoran Başvuru Sistemi Aktif",
    content: "Restoranınızı platformumuza eklemek artık çok daha kolay! Yeni başvuru sistemimizle birkaç dakika içinde başvurunuzu tamamlayabilirsiniz. Editörlerimiz başvurunuzu inceleyerek en kısa sürede geri dönecektir. Onaylanan restoranlar binlerce gezgine ulaşma fırsatı yakalayacak.",
    category: "haber",
    author: "Platform Ekibi",
    publishedAt: "2025-02-01T11:00:00Z",
    image: "https://readdy.ai/api/search-image?query=Turkish%20restaurant%20application%20system%20digital%20platform%20food%20listing%20modern%20clean%20interface%20warm%20amber%20tones&width=800&height=400&seq=ann-apply&orientation=landscape",
    tags: ["restoran", "başvuru", "yeni özellik"],
  },
  {
    id: "ann-4",
    title: "Kış Tatili Kampanyası: Kapadokya'da Özel Fırsatlar",
    content: "Kapadokya'nın büyülü kış manzarasını keşfetmek için harika bir fırsat! Platformumuzdaki seçili konaklama işletmeleri kış sezonu için özel fiyatlar sunuyor. Balon turları, yeraltı şehirleri ve peri bacaları arasında unutulmaz bir kış tatili için hemen inceleyin.",
    category: "kampanya",
    author: "Editör Ekibi",
    publishedAt: "2025-02-10T08:00:00Z",
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20winter%20snow%20fairy%20chimneys%20hot%20air%20balloon%20Turkey%20magical%20landscape%20cold%20season&width=800&height=400&seq=ann-kapadokya&orientation=landscape",
    tags: ["kapadokya", "kış", "kampanya", "konaklama"],
  },
  {
    id: "ann-5",
    title: "Gaziantep Mutfağı Özel Dosyası",
    content: "UNESCO Yaratıcı Şehirler Ağı'nda yer alan Gaziantep'in eşsiz mutfağını mercek altına aldık. Baklava ustalarından kebap sırlarına, fıstıklı tatlılardan yöresel mezzelere kadar Gaziantep mutfağının tüm inceliklerini bu özel dosyamızda bulabilirsiniz.",
    category: "blog",
    author: "Zeynep Kaya",
    publishedAt: "2025-02-15T10:30:00Z",
    image: "https://readdy.ai/api/search-image?query=Gaziantep%20Turkish%20cuisine%20baklava%20kebab%20food%20spread%20traditional%20dishes%20colorful%20meze%20pistachio&width=800&height=400&seq=ann-gaziantep&orientation=landscape",
    tags: ["gaziantep", "mutfak", "blog"],
  },
  {
    id: "ann-6",
    title: "Gold Üyelik Avantajları Genişledi",
    content: "Gold üyelerimize sunduğumuz avantajlar daha da büyüdü! Artık Gold üyeler liste başı sıralama, öne çıkan etiket ve 3x daha fazla görüntülenmenin yanı sıra aylık istatistik raporları ve öncelikli destek hizmetinden de yararlanabilecek. Detaylar için Gold Üyelik sayfamızı ziyaret edin.",
    category: "haber",
    author: "Platform Ekibi",
    publishedAt: "2025-03-01T09:00:00Z",
    image: "https://readdy.ai/api/search-image?query=gold%20membership%20premium%20benefits%20luxury%20business%20listing%20platform%20upgrade%20VIP%20crown%20award&width=800&height=400&seq=ann-gold&orientation=landscape",
    tags: ["gold", "üyelik", "avantaj"],
  },
  {
    id: "ann-7",
    title: "Ege Kıyıları Yaz Rehberi 2025",
    content: "Bodrum'dan Çeşme'ye, Alaçatı'dan Datça'ya Ege'nin en güzel koylarını ve plajlarını derledik. Yaz tatilini planlayanlar için konaklama önerileri, yerel restoranlar ve gizli kalmış koylar bu rehberde sizi bekliyor.",
    category: "blog",
    author: "Selin Arslan",
    publishedAt: "2025-03-10T10:00:00Z",
    image: "https://readdy.ai/api/search-image?query=Aegean%20coast%20Turkey%20summer%20beach%20Bodrum%20Cesme%20turquoise%20sea%20sailing%20boats%20beautiful%20cove&width=800&height=400&seq=ann-ege&orientation=landscape",
    tags: ["ege", "yaz", "plaj", "bodrum"],
  },
  {
    id: "ann-8",
    title: "Konaklama Rehberi Güncellendi",
    content: "Türkiye'nin dört bir yanından yeni konaklama işletmeleri platformumuza katıldı. Karadeniz yaylalarından Akdeniz kıyılarına, Kapadokya'nın peri bacalarından İstanbul'un tarihi semtlerine kadar yüzlerce seçenek sizi bekliyor.",
    category: "haber",
    author: "Platform Ekibi",
    publishedAt: "2025-03-20T09:00:00Z",
    image: "https://readdy.ai/api/search-image?query=Turkey%20accommodation%20hotel%20boutique%20cozy%20interior%20warm%20lighting%20traditional%20decor%20Anatolian%20style&width=800&height=400&seq=ann-acc&orientation=landscape",
    tags: ["konaklama", "güncelleme"],
  },
];

const ITEMS_PER_PAGE = 5;

// ── Highlight helper ─────────────────────────────────────────
const HighlightText = ({ text, query }: { text: string; query: string }) => {
  if (!query.trim()) return <>{text}</>;
  const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
  const parts = text.split(regex);
  return (
    <>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark key={i} className="bg-amber-200 text-amber-900 rounded px-0.5 not-italic font-semibold">
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
};

// ── Share Buttons ─────────────────────────────────────────────
const ShareButtons = ({ title, pageUrl }: { title: string; pageUrl: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(pageUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    });
  }, [pageUrl]);

  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(pageUrl)}`;
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(title + " — " + pageUrl)}`;

  return (
    <div className="flex items-center gap-2 mt-6 pt-6 border-t border-stone-100 flex-wrap">
      <span className="text-xs font-semibold text-stone-400 uppercase tracking-wider mr-1">Paylaş:</span>
      <a
        href={twitterUrl}
        target="_blank"
        rel="nofollow noreferrer"
        className="flex items-center gap-1.5 px-3 py-2 bg-stone-900 text-white text-xs font-semibold rounded-xl hover:bg-stone-700 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-twitter-x-line"></i> Twitter
      </a>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="nofollow noreferrer"
        className="flex items-center gap-1.5 px-3 py-2 bg-emerald-500 text-white text-xs font-semibold rounded-xl hover:bg-emerald-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-whatsapp-line"></i> WhatsApp
      </a>
      <button
        onClick={handleCopy}
        className={`flex items-center gap-1.5 px-3 py-2 text-xs font-semibold rounded-xl transition-all cursor-pointer whitespace-nowrap ${
          copied ? "bg-amber-500 text-white" : "bg-stone-100 text-stone-600 hover:bg-stone-200"
        }`}
      >
        <i className={copied ? "ri-checkbox-circle-line" : "ri-links-line"}></i>
        {copied ? "Kopyalandı!" : "Linki Kopyala"}
      </button>
    </div>
  );
};

// ── Pagination ────────────────────────────────────────────────
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (p: number) => void;
}

const Pagination = ({ currentPage, totalPages, onPageChange }: PaginationProps) => {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-1.5 mt-6 pt-4 border-t border-stone-100">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`flex items-center gap-1 px-3 py-2 rounded-xl text-xs font-medium transition-all whitespace-nowrap ${
          currentPage === 1
            ? "bg-stone-50 text-stone-300 cursor-not-allowed"
            : "bg-stone-100 text-stone-600 hover:bg-stone-200 cursor-pointer"
        }`}
      >
        <i className="ri-arrow-left-s-line"></i> Önceki
      </button>

      {pages.map((p) => {
        const isNear = Math.abs(p - currentPage) <= 1 || p === 1 || p === totalPages;
        if (!isNear) {
          if (p === currentPage - 2 || p === currentPage + 2) {
            return <span key={p} className="text-stone-300 text-xs px-1">…</span>;
          }
          return null;
        }
        return (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`w-8 h-8 flex items-center justify-center rounded-xl text-xs font-semibold transition-all cursor-pointer ${
              p === currentPage
                ? "bg-amber-500 text-white"
                : "bg-stone-100 text-stone-600 hover:bg-amber-100 hover:text-amber-700"
            }`}
          >
            {p}
          </button>
        );
      })}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`flex items-center gap-1 px-3 py-2 rounded-xl text-xs font-medium transition-all whitespace-nowrap ${
          currentPage === totalPages
            ? "bg-stone-50 text-stone-300 cursor-not-allowed"
            : "bg-stone-100 text-stone-600 hover:bg-stone-200 cursor-pointer"
        }`}
      >
        Sonraki <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
};

// ── Main Page ─────────────────────────────────────────────────
const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [selectedCategory, setSelectedCategory] = useState("Tümü");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedAnn, setSelectedAnn] = useState<Announcement | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewMode, setViewMode] = useState<"split" | "grid">("split");

  useEffect(() => {
    document.title = "Duyurular & Blog — Türkiye Seyahat Rehberi";
    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", "Türkiye Seyahat Rehberi'nin güncel haberleri, duyuruları ve blog yazıları. Yeni özellikler, kampanyalar ve seyahat ipuçları.");
    setMeta("og:title", "Duyurular & Blog — Türkiye Seyahat Rehberi", true);
    return () => { document.title = "Türkiye Seyahat Rehberi"; };
  }, []);

  useEffect(() => {
    const stored: Announcement[] = JSON.parse(localStorage.getItem("siteAnnouncements") || "[]");
    const combined = [...stored, ...SEED_ANNOUNCEMENTS]
      .filter((a, idx, arr) => arr.findIndex((x) => x.id === a.id) === idx)
      .sort((a, b) => {
        if (a.pinned && !b.pinned) return -1;
        if (!a.pinned && b.pinned) return 1;
        return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
      });
    setAnnouncements(combined);
    if (combined.length > 0) setSelectedAnn(combined[0]);
  }, []);

  // Reset page when filters change
  useEffect(() => { setCurrentPage(1); }, [selectedCategory, searchQuery]);

  const categories = ["Tümü", "Haber", "Duyuru", "Blog", "Kampanya"];

  const filtered = useMemo(() => {
    return announcements.filter((a) => {
      const matchCat = selectedCategory === "Tümü" || CATEGORY_LABELS[a.category] === selectedCategory;
      const matchSearch = !searchQuery
        || a.title.toLowerCase().includes(searchQuery.toLowerCase())
        || a.content.toLowerCase().includes(searchQuery.toLowerCase());
      return matchCat && matchSearch;
    });
  }, [announcements, selectedCategory, searchQuery]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / ITEMS_PER_PAGE));
  const safePage = Math.min(currentPage, totalPages);
  const paginated = filtered.slice((safePage - 1) * ITEMS_PER_PAGE, safePage * ITEMS_PER_PAGE);

  const handlePageChange = (p: number) => {
    setCurrentPage(p);
    // Select first item of new page
    const newPageItems = filtered.slice((p - 1) * ITEMS_PER_PAGE, p * ITEMS_PER_PAGE);
    if (newPageItems.length > 0) setSelectedAnn(newPageItems[0]);
    window.scrollTo({ top: 300, behavior: "smooth" });
  };

  const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" });

  const pageUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-stone-900 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Turkey%20travel%20news%20blog%20announcement%20editorial%20magazine%20layout%20warm%20amber%20tones%20beautiful%20landscape&width=1400&height=400&seq=ann-hero&orientation=landscape"
          alt="Duyurular"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
          <span className="text-amber-400 text-sm font-semibold uppercase tracking-widest">Güncel İçerikler</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-2 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Duyurular & Blog
          </h1>
          <p className="text-stone-300 text-base max-w-xl mx-auto">
            Platform haberleri, seyahat ipuçları, kampanyalar ve editörlerimizin özel blog yazıları.
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="sticky top-16 z-30 bg-white border-b border-stone-100 py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
          <div className="flex items-center bg-stone-50 border border-stone-200 rounded-full px-4 py-2 gap-2 flex-1 max-w-xs">
            <i className="ri-search-line text-stone-400 text-sm"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Başlık veya içerik ara..."
              className="bg-transparent text-sm text-stone-700 outline-none flex-1"
            />
            {searchQuery && (
              <button onClick={() => setSearchQuery("")} className="w-4 h-4 flex items-center justify-center text-stone-400 hover:text-stone-600 cursor-pointer">
                <i className="ri-close-line text-xs"></i>
              </button>
            )}
          </div>
          {/* View mode toggle */}
          <div className="flex items-center bg-stone-100 rounded-full p-1 gap-1 flex-shrink-0">
            <button
              onClick={() => setViewMode("split")}
              className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                viewMode === "split" ? "bg-white text-stone-800" : "text-stone-500 hover:text-stone-700"
              }`}
            >
              <i className="ri-layout-column-line"></i> Liste
            </button>
            <button
              onClick={() => setViewMode("grid")}
              className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                viewMode === "grid" ? "bg-white text-stone-800" : "text-stone-500 hover:text-stone-700"
              }`}
            >
              <i className="ri-grid-line"></i> Kart
            </button>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            {categories.map((cat) => {
              const count = cat === "Tümü"
                ? announcements.length
                : announcements.filter((a) => CATEGORY_LABELS[a.category] === cat).length;
              return (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`flex items-center gap-1.5 text-xs px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap border ${
                    selectedCategory === cat
                      ? "bg-stone-900 text-white border-stone-900"
                      : "bg-white text-stone-600 border-stone-200 hover:border-stone-400"
                  }`}
                >
                  {cat}
                  {count > 0 && (
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${
                      selectedCategory === cat ? "bg-white/20 text-white" : "bg-stone-100 text-stone-500"
                    }`}>
                      {count}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {filtered.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-newspaper-line text-stone-300 text-4xl"></i>
              </div>
              <p className="text-stone-500 font-medium mb-1">İçerik bulunamadı</p>
              <p className="text-stone-400 text-sm">Arama kriterlerinize uygun içerik yok.</p>
              <button
                onClick={() => { setSearchQuery(""); setSelectedCategory("Tümü"); }}
                className="mt-4 px-4 py-2 text-sm text-amber-600 border border-amber-200 rounded-full hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Filtreleri Temizle
              </button>
            </div>
          ) : viewMode === "grid" ? (
            /* ── GRID VIEW ── */
            <>
              <div className="flex items-center justify-between mb-6">
                <p className="text-xs text-stone-400 font-medium uppercase tracking-wider">
                  {filtered.length} içerik
                  {totalPages > 1 && <span className="ml-2">· Sayfa {safePage}/{totalPages}</span>}
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {paginated.map((ann) => (
                  <article
                    key={ann.id}
                    onClick={() => { setSelectedAnn(ann); setViewMode("split"); window.scrollTo({ top: 300, behavior: "smooth" }); }}
                    className="group bg-white rounded-2xl border border-stone-100 hover:border-amber-200 overflow-hidden cursor-pointer transition-all hover:scale-[1.01] duration-200"
                  >
                    {ann.image ? (
                      <div className="relative h-44 overflow-hidden">
                        <img
                          src={ann.image}
                          alt={ann.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                        <div className="absolute top-3 left-3 flex items-center gap-1.5">
                          {ann.pinned && (
                            <span className="flex items-center gap-1 bg-amber-500 text-white text-xs px-2 py-0.5 rounded-full font-semibold">
                              <i className="ri-pushpin-fill text-xs"></i> Sabit
                            </span>
                          )}
                          <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${CATEGORY_COLORS[ann.category]}`}>
                            {CATEGORY_LABELS[ann.category]}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="h-20 bg-gradient-to-br from-stone-100 to-stone-50 flex items-center justify-center">
                        <i className="ri-newspaper-line text-stone-300 text-3xl"></i>
                      </div>
                    )}
                    <div className="p-5">
                      {!ann.image && (
                        <div className="flex items-center gap-1.5 mb-2">
                          {ann.pinned && <i className="ri-pushpin-fill text-amber-500 text-xs"></i>}
                          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${CATEGORY_COLORS[ann.category]}`}>
                            {CATEGORY_LABELS[ann.category]}
                          </span>
                        </div>
                      )}
                      <h3 className="font-bold text-stone-900 text-base leading-snug mb-2 line-clamp-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                        <HighlightText text={ann.title} query={searchQuery} />
                      </h3>
                      <p className="text-stone-500 text-xs leading-relaxed line-clamp-3 mb-3">
                        <HighlightText text={ann.content} query={searchQuery} />
                      </p>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-1.5 text-xs text-stone-400">
                          <i className="ri-user-line"></i>
                          <span>{ann.author}</span>
                        </div>
                        <span className="text-xs text-stone-400">{formatDate(ann.publishedAt)}</span>
                      </div>
                      {ann.tags && ann.tags.length > 0 && (
                        <div className="flex flex-wrap gap-1 mt-3 pt-3 border-t border-stone-50">
                          {ann.tags.slice(0, 3).map((tag) => (
                            <span key={tag} className="text-xs bg-stone-100 text-stone-500 px-2 py-0.5 rounded-full">#{tag}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  </article>
                ))}
              </div>
              {/* Grid Pagination */}
              <div className="mt-10">
                <Pagination currentPage={safePage} totalPages={totalPages} onPageChange={handlePageChange} />
              </div>
            </>
          ) : (
            /* ── SPLIT VIEW ── */
            <div className="flex gap-8 items-start">
              {/* Left: Paginated List */}
              <div className="w-80 flex-shrink-0">
                {/* Count + page info */}
                <div className="flex items-center justify-between mb-4">
                  <p className="text-xs text-stone-400 font-medium uppercase tracking-wider">
                    {filtered.length} içerik
                  </p>
                  {totalPages > 1 && (
                    <span className="text-xs text-stone-400">
                      Sayfa {safePage}/{totalPages}
                    </span>
                  )}
                </div>

                <div className="space-y-2">
                  {paginated.map((ann) => (
                    <button
                      key={ann.id}
                      onClick={() => setSelectedAnn(ann)}
                      className={`w-full text-left p-4 rounded-xl border transition-all cursor-pointer group ${
                        selectedAnn?.id === ann.id
                          ? "border-amber-400 bg-amber-50"
                          : "border-stone-100 bg-white hover:border-amber-200 hover:bg-stone-50"
                      }`}
                    >
                      {/* Thumbnail + meta */}
                      <div className="flex gap-3">
                        {ann.image && (
                          <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0">
                            <img src={ann.image} alt={ann.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-1.5 mb-1.5 flex-wrap">
                            {ann.pinned && (
                              <span className="flex items-center gap-0.5 text-xs text-amber-600 font-semibold">
                                <i className="ri-pushpin-fill text-xs"></i>
                              </span>
                            )}
                            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${CATEGORY_COLORS[ann.category]}`}>
                              {CATEGORY_LABELS[ann.category]}
                            </span>
                          </div>
                          <h3 className="font-semibold text-stone-900 text-sm leading-snug mb-1 line-clamp-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                            <HighlightText text={ann.title} query={searchQuery} />
                          </h3>
                          {searchQuery && (
                            <p className="text-xs text-stone-500 line-clamp-1 mb-0.5">
                              <HighlightText text={ann.content.slice(0, 90)} query={searchQuery} />
                            </p>
                          )}
                          <p className="text-xs text-stone-400">{formatDate(ann.publishedAt)}</p>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>

                {/* Pagination */}
                <Pagination
                  currentPage={safePage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>

              {/* Right: Detail */}
              <div className="flex-1 min-w-0">
                {selectedAnn ? (
                  <article className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
                    {selectedAnn.image && (
                      <div className="relative h-72 overflow-hidden">
                        <img
                          src={selectedAnn.image}
                          alt={selectedAnn.title}
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent"></div>
                        <div className="absolute top-4 left-4 flex items-center gap-2">
                          {selectedAnn.pinned && (
                            <span className="flex items-center gap-1 bg-amber-500 text-white text-xs px-2.5 py-1 rounded-full font-semibold">
                              <i className="ri-pushpin-fill text-xs"></i> Sabit
                            </span>
                          )}
                          <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${CATEGORY_COLORS[selectedAnn.category]}`}>
                            {CATEGORY_LABELS[selectedAnn.category]}
                          </span>
                        </div>
                        {/* Nav arrows on image */}
                        <div className="absolute bottom-4 right-4 flex items-center gap-2">
                          <button
                            onClick={() => {
                              const idx = filtered.findIndex((a) => a.id === selectedAnn.id);
                              if (idx > 0) setSelectedAnn(filtered[idx - 1]);
                            }}
                            disabled={filtered.findIndex((a) => a.id === selectedAnn.id) === 0}
                            className="w-8 h-8 flex items-center justify-center bg-black/40 hover:bg-black/60 disabled:opacity-30 text-white rounded-full transition-colors cursor-pointer"
                          >
                            <i className="ri-arrow-left-s-line"></i>
                          </button>
                          <span className="text-white/70 text-xs">
                            {filtered.findIndex((a) => a.id === selectedAnn.id) + 1} / {filtered.length}
                          </span>
                          <button
                            onClick={() => {
                              const idx = filtered.findIndex((a) => a.id === selectedAnn.id);
                              if (idx < filtered.length - 1) setSelectedAnn(filtered[idx + 1]);
                            }}
                            disabled={filtered.findIndex((a) => a.id === selectedAnn.id) === filtered.length - 1}
                            className="w-8 h-8 flex items-center justify-center bg-black/40 hover:bg-black/60 disabled:opacity-30 text-white rounded-full transition-colors cursor-pointer"
                          >
                            <i className="ri-arrow-right-s-line"></i>
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="p-8">
                      <div className="flex items-center gap-3 mb-4 flex-wrap">
                        {!selectedAnn.image && (
                          <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${CATEGORY_COLORS[selectedAnn.category]}`}>
                            {CATEGORY_LABELS[selectedAnn.category]}
                          </span>
                        )}
                        <div className="flex items-center gap-1.5 text-xs text-stone-400">
                          <i className="ri-user-line"></i>
                          <span>{selectedAnn.author}</span>
                        </div>
                        <div className="flex items-center gap-1.5 text-xs text-stone-400">
                          <i className="ri-calendar-line"></i>
                          <span>{formatDate(selectedAnn.publishedAt)}</span>
                        </div>
                      </div>

                      <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-6 leading-snug" style={{ fontFamily: "'Playfair Display', serif" }}>
                        {selectedAnn.title}
                      </h2>

                      <p className="text-stone-600 leading-relaxed text-base">{selectedAnn.content}</p>

                      {selectedAnn.tags && selectedAnn.tags.length > 0 && (
                        <div className="flex flex-wrap gap-2 mt-8 pt-6 border-t border-stone-100">
                          {selectedAnn.tags.map((tag) => (
                            <span key={tag} className="text-xs bg-stone-100 text-stone-600 px-3 py-1 rounded-full">
                              #{tag}
                            </span>
                          ))}
                        </div>
                      )}

                      <ShareButtons title={selectedAnn.title} pageUrl={pageUrl} />

                      {/* Prev / Next navigation */}
                      {(() => {
                        const idx = filtered.findIndex((a) => a.id === selectedAnn.id);
                        const prev = idx > 0 ? filtered[idx - 1] : null;
                        const next = idx < filtered.length - 1 ? filtered[idx + 1] : null;
                        if (!prev && !next) return null;
                        return (
                          <div className="flex gap-3 mt-6 pt-6 border-t border-stone-100">
                            {prev && (
                              <button
                                onClick={() => setSelectedAnn(prev)}
                                className="flex-1 flex items-center gap-2 p-3 bg-stone-50 hover:bg-amber-50 border border-stone-100 hover:border-amber-200 rounded-xl transition-all cursor-pointer text-left"
                              >
                                <i className="ri-arrow-left-line text-stone-400 flex-shrink-0"></i>
                                <div className="min-w-0">
                                  <p className="text-xs text-stone-400 mb-0.5">Önceki</p>
                                  <p className="text-sm font-semibold text-stone-700 line-clamp-1">{prev.title}</p>
                                </div>
                              </button>
                            )}
                            {next && (
                              <button
                                onClick={() => setSelectedAnn(next)}
                                className="flex-1 flex items-center gap-2 p-3 bg-stone-50 hover:bg-amber-50 border border-stone-100 hover:border-amber-200 rounded-xl transition-all cursor-pointer text-right justify-end"
                              >
                                <div className="min-w-0">
                                  <p className="text-xs text-stone-400 mb-0.5">Sonraki</p>
                                  <p className="text-sm font-semibold text-stone-700 line-clamp-1">{next.title}</p>
                                </div>
                                <i className="ri-arrow-right-line text-stone-400 flex-shrink-0"></i>
                              </button>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  </article>
                ) : (
                  <div className="bg-white rounded-2xl border border-stone-100 h-64 flex items-center justify-center">
                    <p className="text-stone-400 text-sm">Okumak için bir içerik seçin</p>
                  </div>
                )}
              </div>
            </div>
          )
          }
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 bg-stone-50 border-t border-stone-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h3 className="text-xl font-bold text-stone-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            İşletmenizi Platforma Ekleyin
          </h3>
          <p className="text-stone-500 text-sm mb-6 max-w-md mx-auto">
            Restoranınızı veya konaklama işletmenizi binlerce gezgine tanıtın.
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/restaurant-apply"
              className="flex items-center gap-2 px-5 py-2.5 bg-amber-500 text-white rounded-full text-sm font-semibold hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-store-2-line"></i> Restoran Ekle
            </Link>
            <Link
              to="/hotel-apply"
              className="flex items-center gap-2 px-5 py-2.5 bg-stone-900 text-white rounded-full text-sm font-semibold hover:bg-stone-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-hotel-line"></i> Konaklama Ekle
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AnnouncementsPage;
